/* Utilities */


import { createSelector } from 'reselect'

const mediaPlayer = (state) => state.mediaPlayer

export const getList = createSelector(
  [ mediaPlayer ],
  (mediaPlayer) => {
    return Object.assign(
      {},
      { list: mediaPlayer.list.list }
    )
  }
)

export const getFilter = createSelector(
  [ mediaPlayer ],
  (mediaPlayer) => {
    return Object.assign(
      {},
      { filter: mediaPlayer.list.filter }
    )
  }
)

export const getSort = createSelector(
  [ mediaPlayer ],
  (mediaPlayer) => {
    return Object.assign(
      {},
      { sort: mediaPlayer.list.sort }
    )
  }
)

export const getPagination = createSelector(
  [ mediaPlayer ],
  (mediaPlayer) => {
    return Object.assign(
      {},
      {
        pagination: mediaPlayer.list.pagination
      }
    )
  }
)

export const getQuery = createSelector(
  [ mediaPlayer ],
  (mediaPlayer) => {
    return Object.assign(
      {},
      {
        query: mediaPlayer.list.query
      }
    )
  }
)

export const getBulkSync = createSelector(
  [ mediaPlayer ],
  (mediaPlayer) => {
    return Object.assign(
      {},
      {
        bulkSync: mediaPlayer.list.bulkSync
      }
    )
  }
)

export const getItem = (state, uid) => {
  const {
    items,
    status,
    surfaces,
    expanded,
    syncHint,
    syncing
  } = state.mediaPlayer.list
  const surfaceList = _.map(surfaces[uid], (surface, surfaceId) => {
    return Object.assign({}, surface, {uid: surfaceId})
  }).sort((a, b) => {return new Date(a.timeCreated) > new Date(b.timeCreated)})
  return Object.assign(
    {},
    items[uid],
    {
      syncHint: syncHint[uid],
      expanded: expanded[uid], // expanded state of mediaPlayer identified by uid
      surfaces: surfaces[uid], // surfaces of mediaPlayer identified by uid
      surfaceList,
      syncing: !!syncing[uid],
    },
    { uid: uid }
  )
}

export const getSurfaceItem = (state, uid) => {
  const { surfaces } = state.mediaPlayer.list
  if (!surfaces) return {}
  const mediaPlayerSurfaces = _.find(
    surfaces,
    (o) => { return o && o[uid]; }
  )
  const surfaceItem = mediaPlayerSurfaces[uid]
  return Object.assign({},  surfaceItem)
}



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/media-player.js